import * as React from "react";
import { useEffect, useCallback, useState } from "react";
import styled from "styled-components";
import QueryHelper from "components/common/QueryHelper";
import { Alert, DropdownButton, MenuItem } from "components/bootstrap";
import { PaginatedList, SearchForm } from "components/common";
import withPaginationQueryParameter from "components/common/withPaginationQueryParameter";
import AuditLogEntriesTable from "auditlog/AuditLogEntriesTable";
import { useAuditLogEntries, getAuditLogExportURL } from "auditlog/hooks/useAuditLog";
import style from "auditlog/AuditLogEntriesStyle.lazy.css";
const PAGE_SIZES = [20, 50, 100, 200, 500];
const queryExamples = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, "Find audit log messages created after the given date:", /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("code", null, "timestamp:>=2017-03-23"), /* @__PURE__ */ React.createElement("br", null)), /* @__PURE__ */ React.createElement("p", null, "Find audit log messages where the action is ", /* @__PURE__ */ React.createElement("code", null, "create"), " or ", /* @__PURE__ */ React.createElement("code", null, "delete"), ":", /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("code", null, "action:create action:delete"), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("code", null, "action:create,delete")));
const fieldMap = {
  actor: "User that triggered the audit event",
  namespace: "Namespace of the audit event; might be different in plugins",
  object: "Object of the audit event; what has been changed",
  action: "Name of the action that has been executed on the object",
  success_status: "If the action failed or succeeded",
  message: "The actual audit event message",
  timestamp: "Timestamp of the audit event"
};
const queryHelpComponent = /* @__PURE__ */ React.createElement(QueryHelper, { entityName: "audit event", example: queryExamples, commonFields: [], fieldMap });
const StyledDropdownButton = styled(DropdownButton)`
  margin-left: 5;
`;
const AuditLogEntries = ({ paginationQueryParameter: { page, pageSize, resetPage } }) => {
  const [query, setQuery] = useState("");
  useEffect(() => {
    style.use();
    return () => style.unuse();
  }, []);
  const { data: paginatedEntries } = useAuditLogEntries({ page, perPage: pageSize, query });
  const _onSearch = useCallback(
    (newQuery, cb) => {
      resetPage();
      setQuery(newQuery);
      cb();
    },
    [resetPage]
  );
  const _onReset = useCallback(() => {
    resetPage();
    setQuery("");
  }, [resetPage]);
  if (!paginatedEntries) {
    return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, "Loading audit log entries...");
  }
  return /* @__PURE__ */ React.createElement("div", { className: "auditlog-entries" }, /* @__PURE__ */ React.createElement("h2", null, "Audit Log Entries", /* @__PURE__ */ React.createElement("span", null, "\xA0", /* @__PURE__ */ React.createElement("small", null, paginatedEntries.total, " total"))), /* @__PURE__ */ React.createElement("div", { className: "auditlog-entries-content" }, /* @__PURE__ */ React.createElement(PaginatedList, { totalItems: paginatedEntries.total, pageSizes: PAGE_SIZES }, /* @__PURE__ */ React.createElement(
    SearchForm,
    {
      onSearch: _onSearch,
      onReset: _onReset,
      queryWidth: 500,
      useLoadingState: true,
      queryHelpComponent
    },
    /* @__PURE__ */ React.createElement(StyledDropdownButton, { id: "export-entries-dropdown", title: "Export Results" }, /* @__PURE__ */ React.createElement(MenuItem, { href: getAuditLogExportURL("json", query), target: "_blank" }, "JSON"), /* @__PURE__ */ React.createElement(MenuItem, { href: getAuditLogExportURL("csv", query), target: "_blank" }, "CSV"))
  ), /* @__PURE__ */ React.createElement(AuditLogEntriesTable, { entries: paginatedEntries.entries }))));
};
export default withPaginationQueryParameter(AuditLogEntries, { pageSizes: PAGE_SIZES });
